<template>
  <div>
    <searchResearchPlan />
  </div>
</template>

<script>
  import searchResearchPlan from "./../researchPlan/searchResearchPlan"
  export default {
    components: {
      searchResearchPlan
    }
  }

</script>

<style>

</style>
